import clockIcon from 'dashboard/assets/images/audit_log_icons/clock.svg';
import configIcon from 'dashboard/assets/images/audit_log_icons/config.svg';
import keyIcon from 'dashboard/assets/images/audit_log_icons/key.svg';
import peopleCheckIcon from 'dashboard/assets/images/audit_log_icons/people-check.svg';
import shieldIcon from 'dashboard/assets/images/audit_log_icons/shield.svg';
import systemConfigIcon from 'dashboard/assets/images/audit_log_icons/system_config.svg';

export const BLUE = 'audit-tag--blue';
export const ORANGE = 'audit-tag--orange';
export const PURPLE = 'audit-tag--purple';
export const GREEN = 'audit-tag--green';
export const GRAY = 'audit-tag--gray';
export const RED = 'audit-tag--red';

export const ICON_BG_KEY = 'audit-icon--green';
export const ICON_BG_PEOPLE = 'audit-icon--blue';
export const ICON_BG_CLOCK = 'audit-icon--orange';
export const ICON_BG_CONFIG = 'audit-icon--purple';
export const ICON_BG_SHIELD = 'audit-icon--red';
export const ICON_BG_SYSTEM = 'audit-icon--gray';

export const auditLogTypes = [
  // Authentication
  {
    id: 'user:sign_in',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.USER.SIGN_IN',
    colorClass: GREEN,
    icon: keyIcon,
    iconBgClass: ICON_BG_KEY,
    category: 'AUDIT_CATEGORIES.AUTHENTICATION',
  },
  {
    id: 'user:sign_out',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.USER.SIGN_OUT',
    colorClass: GREEN,
    icon: keyIcon,
    iconBgClass: ICON_BG_KEY,
    category: 'AUDIT_CATEGORIES.AUTHENTICATION',
  },

  // Authorization & Permissions
  {
    id: 'role:update',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.ROLE.UPDATE',
    colorClass: BLUE,
    icon: peopleCheckIcon,
    iconBgClass: ICON_BG_PEOPLE,
    category: 'AUDIT_CATEGORIES.AUTHORIZATION',
  },
  {
    id: 'team:create',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.TEAM.CREATE',
    colorClass: BLUE,
    icon: peopleCheckIcon,
    iconBgClass: ICON_BG_PEOPLE,
    category: 'AUDIT_CATEGORIES.AUTHORIZATION',
  },
  {
    id: 'team:update',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.TEAM.UPDATE',
    colorClass: BLUE,
    icon: peopleCheckIcon,
    iconBgClass: ICON_BG_PEOPLE,
    category: 'AUDIT_CATEGORIES.AUTHORIZATION',
  },
  {
    id: 'team:destroy',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.TEAM.DESTROY',
    colorClass: BLUE,
    icon: peopleCheckIcon,
    iconBgClass: ICON_BG_PEOPLE,
    category: 'AUDIT_CATEGORIES.AUTHORIZATION',
  },
  {
    id: 'accountuser:create',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.ACCOUNTUSER.CREATE',
    colorClass: BLUE,
    icon: peopleCheckIcon,
    iconBgClass: ICON_BG_PEOPLE,
    category: 'AUDIT_CATEGORIES.AUTHORIZATION',
  },
  {
    id: 'accountuser:update:self',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.ACCOUNTUSER.UPDATE_SELF',
    colorClass: ORANGE,
    icon: clockIcon,
    iconBgClass: ICON_BG_CLOCK,
    category: 'AUDIT_CATEGORIES.USER_AVAILABILITY',
  },
  {
    id: 'accountuser:update:other',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.ACCOUNTUSER.UPDATE_OTHER',
    colorClass: ORANGE,
    icon: clockIcon,
    iconBgClass: ICON_BG_CLOCK,
    category: 'AUDIT_CATEGORIES.USER_AVAILABILITY',
  },
  {
    id: 'inboxmember:create',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.INBOXMEMBER.CREATE',
    colorClass: BLUE,
    icon: peopleCheckIcon,
    iconBgClass: ICON_BG_PEOPLE,
    category: 'AUDIT_CATEGORIES.AUTHORIZATION',
  },
  {
    id: 'inboxmember:destroy',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.INBOXMEMBER.DESTROY',
    colorClass: BLUE,
    icon: peopleCheckIcon,
    iconBgClass: ICON_BG_PEOPLE,
    category: 'AUDIT_CATEGORIES.AUTHORIZATION',
  },
  {
    id: 'teammember:create',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.TEAMMEMBER.CREATE',
    colorClass: BLUE,
    icon: peopleCheckIcon,
    iconBgClass: ICON_BG_PEOPLE,
    category: 'AUDIT_CATEGORIES.AUTHORIZATION',
  },
  {
    id: 'teammember:destroy',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.TEAMMEMBER.DESTROY',
    colorClass: BLUE,
    icon: peopleCheckIcon,
    iconBgClass: ICON_BG_PEOPLE,
    category: 'AUDIT_CATEGORIES.AUTHORIZATION',
  },

  // Data & Configuration
  {
    id: 'automationrule:create',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.AUTOMATIONRULE.CREATE',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'automationrule:update',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.AUTOMATIONRULE.UPDATE',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'automationrule:destroy',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.AUTOMATIONRULE.DESTROY',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'webhook:create',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.WEBHOOK.CREATE',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'webhook:update',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.WEBHOOK.UPDATE',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'webhook:destroy',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.WEBHOOK.DESTROY',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'inbox:create',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.INBOX.CREATE',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'inbox:update',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.INBOX.UPDATE',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'inbox:destroy',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.INBOX.DESTROY',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'macro:create',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.MACRO.CREATE',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'macro:update',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.MACRO.UPDATE',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'macro:destroy',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.MACRO.DESTROY',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'account:update',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.ACCOUNT.UPDATE',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'integrations_hook:create',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.INTEGRATIONS_HOOK.CREATE',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
  {
    id: 'integrations_hook:destroy',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.INTEGRATIONS_HOOK.DESTROY',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },

  // System Events
  {
    id: 'gpt_set_settings',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.GPT_SET_SETTINGS',
    colorClass: GRAY,
    icon: systemConfigIcon,
    iconBgClass: ICON_BG_SYSTEM,
    category: 'AUDIT_CATEGORIES.SYSTEM',
  },
  {
    id: 'click2call_set_settings',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.CLICK2CALL_SET_SETTINGS',
    colorClass: GRAY,
    icon: systemConfigIcon,
    iconBgClass: ICON_BG_SYSTEM,
    category: 'AUDIT_CATEGORIES.SYSTEM',
  },
  {
    id: 'activestorage_attachment:destroy',
    name: 'AUDIT_LOGS_FILTER.FILTER_TYPES.ACTIVESTORAGE_ATTACHMENT.DESTROY',
    colorClass: PURPLE,
    icon: configIcon,
    iconBgClass: ICON_BG_CONFIG,
    category: 'AUDIT_CATEGORIES.CONFIGURATION',
  },
];
